import routes from '@modules/family/family-routes';
import store from '@modules/family/family-store';

export default {
    routes,
    store,
};